import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { ProfilesState } from 'reducers/profiles';

const useProfiles = (): ProfilesState => {
  return useSelector((state: RootState) => state.profiles);
};

export default useProfiles;
